module.exports = __webpack_public_path__ + "151448aa3937f579317191e7a4d911a6.svg";